import React, { useLayoutEffect, useRef, useState } from 'react';
import { TABS, TAB_COLORS } from './chipsConfig';

const CountBadge = ({ count }) => <span key={count} className="qc-tab-count qc-pop">{count}</span>;

export const CategoryTabs = ({ activeTab, counts, onChange }) => {
  const listRef = useRef(null);
  const btnRefs = useRef({});
  const [ink, setInk] = useState({ left: 0, width: 0 });

  useLayoutEffect(() => {
    const measure = () => {
      const el = btnRefs.current[activeTab];
      const list = listRef.current;
      if (!el || !list) return;
      const scrollLeft = list.scrollLeft;
      setInk({ left: el.offsetLeft - scrollLeft + 14, width: Math.max(0, el.offsetWidth - 28) });
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [activeTab]);

  const colors = TAB_COLORS[activeTab];

  return (
    <div ref={listRef} className="qc-tabs" role="tablist" aria-label="Chip categories" data-testid="chip-category-tabs">
      {TABS.map(tab => {
        const c = TAB_COLORS[tab.key];
        const Icon = tab.icon;
        const selected = activeTab === tab.key;
        return (
          <button
            key={tab.key}
            ref={el => { btnRefs.current[tab.key] = el; }}
            role="tab"
            aria-selected={selected}
            className="qc-tab"
            style={{ '--qc-accent': c.accent, '--qc-soft': c.soft, '--qc-tile': c.tile, '--qc-text': c.text }}
            onClick={() => onChange(tab.key)}
            data-testid={`tab-${tab.key}`}
          >
            <span className="qc-tab-icon"><Icon className="w-3.5 h-3.5" /></span>
            {tab.label}
            <CountBadge count={counts[tab.key] || 0} />
          </button>
        );
      })}
      <span className="qc-tab-ink" style={{ left: ink.left, width: ink.width, '--qc-accent': colors.accent }} aria-hidden="true" />
    </div>
  );
};
